<!-- eslint-disable vue/valid-template-root -->
<template></template>

<script>
export default {
  name: 'GoogleAnalytics',
  mounted() {
    const googleAnalyticsCode = this.$store.getters.GOOGLE_ANALYTICS

    const ga4Script = document.createElement('script')
    ga4Script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsCode)

    document.head.appendChild(ga4Script)

    window.dataLayer = window.dataLayer || []
    window.gtag = function() {
      window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())

    window.gtag('config', googleAnalyticsCode)

    console.log('mounted ga component', googleAnalyticsCode)
    this.$emit('init-google-analytics')
  }
}
</script>
